/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

function plural(n: number): number {
  return 5;
}

export default [
  'uz-Cyrl',
  [
    ['ТО', 'ТК'],
    ,
  ],
  ,
  [
    ['Я', 'Д', 'С', 'Ч', 'П', 'Ж', 'Ш'],
    ['якш', 'душ', 'сеш', 'чор', 'пай', 'жум', 'шан'],
    [
      'якшанба', 'душанба', 'сешанба', 'чоршанба', 'пайшанба',
      'жума', 'шанба'
    ],
    ['Як', 'Ду', 'Се', 'Чо', 'Па', 'Жу', 'Ша']
  ],
  [
    ['Я', 'Д', 'С', 'Ч', 'П', 'Ж', 'Ш'],
    ['Якш', 'Душ', 'Сеш', 'Чор', 'Пай', 'Жум', 'Шан'],
    [
      'Якшанба', 'Душанба', 'Сешанба', 'Чоршанба', 'Пайшанба',
      'Жума', 'Шанба'
    ],
    ['Як', 'Ду', 'Се', 'Чо', 'Па', 'Жу', 'Ша']
  ],
  [
    ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
    [
      'янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен',
      'окт', 'ноя', 'дек'
    ],
    [
      'январ', 'феврал', 'март', 'апрел', 'май', 'июн', 'июл',
      'август', 'сентябр', 'октябр', 'ноябр', 'декабр'
    ]
  ],
  [
    ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
    [
      'Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен',
      'Окт', 'Ноя', 'Дек'
    ],
    [
      'Январ', 'Феврал', 'Март', 'Апрел', 'Май', 'Июн', 'Июл',
      'Август', 'Сентябр', 'Октябр', 'Ноябр', 'Декабр'
    ]
  ],
  [['м.а.', 'милодий'], , ['милоддан аввалги', 'милодий']], 1,
  [6, 0], ['dd/MM/yy', 'd MMM, y', 'd MMMM, y', 'EEEE, dd MMMM, y'],
  ['HH:mm', 'HH:mm:ss', 'HH:mm:ss (z)', 'HH:mm:ss (zzzz)'],
  [
    '{1} {0}',
    ,
    ,
  ],
  [',', ' ', ';', '%', '+', '-', 'E', '×', '‰', '∞', 'ҳақиқий сон эмас', ':'],
  ['#,##0.###', '#,##0%', '#,##0.00 ¤', '#E0'], 'сўм', 'Ўзбекистон сўм', plural
];
